module.exports = __webpack_public_path__ + "img/346-74f358.png";